import { MatDialog } from '@angular/material/dialog';
import { Injectable } from '@angular/core';
import { ApiService } from 'app/shared/apis/api.service';
import { BaseService } from 'app/core/services/base.service';
import { DoctorCrmModel } from 'app/models/doctor-crm.model';
import { Observable } from 'rxjs';

interface CreateDoctorCrmRequest {
    crm_number: string;
    uf: string;
}

@Injectable({
    providedIn: 'root',
})
export class DoctorCrmService extends BaseService<DoctorCrmModel> {
    constructor(api: ApiService, _matDialog: MatDialog) {
        super(api, _matDialog, 'doctor-crm');
    }

    getCrms(doctorId: number): Observable<DoctorCrmModel[]> {
        return this.api.getSub(`${this.endpoint}/doctor/${doctorId}`);
    }

    createCrm(doctorId: number, crm: CreateDoctorCrmRequest): Observable<DoctorCrmModel> {
        return this.api.postSub(`${this.endpoint}/doctor/${doctorId}`, crm);
    }

    updateCrm(doctorCrmId: number, crm: Partial<DoctorCrmModel>): Observable<DoctorCrmModel> {
        return this.api.putSub(`${this.endpoint}/${doctorCrmId}`, crm);
    }

    deleteCrm(doctorCrmId: number): Observable<void> {
        return this.api.deleteSub(`${this.endpoint}/${doctorCrmId}`);
    }
}
